import { useAuth0 } from "@auth0/auth0-react";
import { useAuth0User } from "@src/components/user/queries/get-auth0-user";

export type EmailVerificationStatus = {
	/** True when Auth0 hasn't confirmed the user's email yet (new signups) */
	needsEmailVerification: boolean;
	/** True if any verification action is required */
	hasVerificationPending: boolean;
};

export function useEmailVerificationStatus(): EmailVerificationStatus {
	const {
		isAuthenticated,
		isLoading: isAuthLoading,
		user: auth0SessionUser,
	} = useAuth0();
	const shouldCheckBackend =
		isAuthenticated &&
		!isAuthLoading &&
		auth0SessionUser?.email_verified !== true;
	const { data: auth0User } = useAuth0User(shouldCheckBackend);

	const needsEmailVerification =
		auth0SessionUser?.email_verified === true
			? false
			: auth0User !== null && auth0User !== undefined
				? auth0User.emailVerified === false
				: auth0SessionUser?.email_verified === false;

	return {
		needsEmailVerification,
		hasVerificationPending: needsEmailVerification,
	};
}
